import {useDeleteFromCartMutation} from 'modules/cart/services';
import {useCallback} from 'react';

interface IProps {
    id?: number;
}

export const useRemoveProductFromCart = ({id}: IProps) => {
    const [apiDeleteProductFromCart] = useDeleteFromCartMutation();

    return useCallback(
        async (cb?: () => void) => {
            if (!id) {
                return;
            }

            try {
                await apiDeleteProductFromCart({id}).then((result) => {
                    if ('error' in result) {
                        return;
                    }

                    cb?.();
                });
            } catch (e) {
                console.error(e);
            }
        },
        [apiDeleteProductFromCart, id],
    );
};
